import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fruit-cut/2025-03/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/fruit-cut/2025-03',
  name: 'activity_fruit_cut_2025_03',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '切水果 瘦手臂',
  },
}

export default [indexRoute]
